function parseData(data) {
    if((!data) || data.length==0){
        return null;
      }
      else{
        return JSON.stringify(data);
      }
  
   }
  function parseUpdateSubmissionStatus(res) {
    return JSON.stringify(res);
  }
  
  function serviceFactory( {api} ) {
    const getBpData = ({inputParam, metaData}) =>
      api
      .getBpData(inputParam, metaData)
      .then(parseData);

      const getContactDetailsListData = ({inputParam, metaData}) =>
      api
      .getContactDetailsListData(inputParam, metaData)
      .then(parseData);

      const saveForm = ({inputParam, metaData}) =>
      api
      .saveForm(inputParam, metaData)
      .then(parseData);

      const saveContactDetails = ({inputParam, metaData}) =>
      api
      .saveContactDetails(inputParam, metaData)
      .then(parseData);
    
      const signContact = ({ inputParam, metaData }) => 
      api
      .signContact(inputParam, metaData)
      .then(parseUpdateSubmissionStatus);
  
    return {
      getBpData,
      getContactDetailsListData,
      saveForm,
      saveContactDetails,
      signContact
    };
  }
  
  module.exports = serviceFactory;